export enum Currency {
  USD = 'USD',
  CAD = 'CAD',
  EUR = 'EUR',
  GBP = 'GBP',
  JPY = 'JPY',
  AUD = 'AUD',
  CHF = 'CHF',
  CNY = 'CNY',
  INR = 'INR',
  BRL = 'BRL',
  ZAR = 'ZAR',
  MXN = 'MXN',
  SEK = 'SEK',
  SGD = 'SGD',
  NZD = 'NZD',
  HKD = 'HKD',
  NOK = 'NOK',
  KRW = 'KRW',
  TRY = 'TRY',
  DKK = 'DKK',
  AED = 'AED',
  SAR = 'SAR'
}

export interface CurrencySettings {
  countryCode: string
  code: Currency
  symbol: string
  rate?: number
}